// @flow
export { default } from './ActivityTimestamp';
